import { __assign } from "tslib";
import { createUserRolesApi } from '.';
import { createHttpTestKit } from '../http/test-kit';
import { createFakePostResponder, createFakeGetResponder, createFakePutResponder, createFakeDeleteResponder } from '../test-utils';
export var createUserRolesApiTestkit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createUserRolesApi('', fakeHttp);
    var userRolesRelativePath = '/roles';
    var userRolesUriUrl = function (id) { return userRolesRelativePath + "/" + id; };
    var testKit = {
        whenAddUserRole: function (dto) { return createFakePostResponder(fakeHttp, userRolesRelativePath)(dto); },
        whenUpdateUserRole: function (dto) { return createFakePutResponder(fakeHttp, userRolesUriUrl(dto.id))(dto); },
        whenGetUserRole: function (dto) { return createFakeGetResponder(fakeHttp, userRolesUriUrl(dto.id)); },
        whenGetAll: function () { return createFakeGetResponder(fakeHttp, "" + userRolesRelativePath); },
        whenDeleteUserRole: function (dto) { return createFakeDeleteResponder(fakeHttp, userRolesUriUrl(dto.id) + "/" + (!!dto.newRoleId ? "?newRoleId=" + dto.newRoleId : '')); },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map